import jwt_decode from 'jwt-decode';
import http from "../../src/services/http-common";
import { HelperConstant } from './HelperConstant';
import { ITokenModel } from '../models/ITokenModel';
import createHttpInstance from '../../src/services/http-common';

export const isTokenExpired = () => {
    let token: string = localStorage.getItem("authUser") as string;
    let result: any;
    if (token) {
        let date: Date = getTokenExpirationDate(token);
        result = (date.valueOf() >= new Date().valueOf());

        if (result === true) {
            return false;
            // let hours = getDifferenceInHours(date.valueOf(), new Date().valueOf());
            // let data = ProcessToken(hours <= 8, token);
            // return hours >= 8 ? false : true;
        }
        else {
            ProcessToken(false, token)
        }
    }
    return false;
}

export const ProcessToken = (isRefresh: boolean, token: any) => {
    if (isRefresh === true) {
        refreshToken(token).then((res: any) => {
            localStorage.setItem("authUser", JSON.stringify(res.data));
        });
    }
    else {
        localStorage.removeItem("authUser");
        window.location.href = "/";
    }
}

export const isAdmin = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return parseInt(tokendata?.RoleId) == HelperConstant.Roles.Admin ? true : false;
    }
    catch (Error) {
        return null;
    }
}
 
export const isSuperAdmin = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return parseInt(tokendata?.RoleId) == HelperConstant.Roles.Super_Admin ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const getDecodedAccessToken = (token: string) => {
    try {
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata;
    }
    catch (Error) {
        return null;
    }
}

export const isRider = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return parseInt(tokendata?.RoleId) == HelperConstant.Roles.Rider ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const isSeo = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.RoleId == HelperConstant.Roles.SEO ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const isOperationalManager = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.RoleId == HelperConstant.Roles.Operational_Manager ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const isTeleCaller = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.RoleId == HelperConstant.Roles.Tele_Caller ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const IsVendor = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.RoleId == HelperConstant.Roles.Vendor ? true : false;
    }
    catch (Error) {
        return null;
    }
}

export const getPersonId = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.PersonId;
    }
    catch (Error) {
        return null;
    }
}

export const getPersonName = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.Mobile;
    }
    catch (Error) {
        return null;
    }
}

export const getRoleId = () => {
    try {
        let token: string = localStorage.getItem("authUser") as string;
        let tokendata: ITokenModel = jwt_decode(token);
        return tokendata?.RoleId;
    }
    catch (Error) {
        return null;
    }
}

function getTokenExpirationDate(token: string): Date {
    let decoded: ITokenModel = jwt_decode(token);
    if (decoded === undefined) return new Date();
    let date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
}

// function getDifferenceInDays(date1: number, date2: number) {
//     const diffInDays = Math.abs(date2 - date1);
//     return diffInDays / (1000 * 60 * 60 * 24);
// }

async function refreshToken(token: any) {
    const httpCommon = await createHttpInstance();
    return httpCommon.post(`/auth/refreshToken/${token}`).catch((err: Error) => {
        localStorage.removeItem("authUser");
        window.location.href = "/login";
    });
}